import React, { useState } from 'react';
import ImageDialog from '../../common/ImageDialog';
import { Icon } from '../../common/AppShell';
import Switch from '../Switch/Switch';

import LoadFile from '../../assets/img/load-photo.webp';

function ItemEditor({ item, onChange, onDelete }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [dialogVisible, setDialogVisible] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (['weight', 'price'].includes(name)) {
      newValue = parseFloat(value) || 0;
    }
    onChange({ ...item, [name]: newValue });
  };

  const toggleStopList = () => {
    onChange({ ...item, onStop: !item.onStop });
  };

  const handleUpload = (uploadedUrl) => {
    onChange({ ...item, image: uploadedUrl });
    setDialogVisible(false);
  };

  const confirm = () => {
    const message = `Вы действительно хотите удалить ${item.name === '' ? 'новое блюдо' : item.name}? Это действие безвозвратно!`;
    if (window.confirm(message)) {
      onDelete();
    }
  };

  return (
    <article className={`menu-item-card ${item.onStop ? 'stopped' : ''}`}>
      <div className="menu-item-summary">
        <button type="button" className="item-image-button" onClick={() => setDialogVisible(true)}>
          <img src={item.image || LoadFile} alt="" />
        </button>

        <div className="item-copy">
          <input
            type="text"
            name="name"
            value={item.name || ''}
            onChange={handleChange}
            placeholder="Название"
            className="inline-input strong"
          />
          <input
            type="text"
            name={item.options ? 'options' : 'serving'}
            value={item.options || item.serving || ''}
            onChange={handleChange}
            placeholder={item.options ? 'Цена за 100г' : 'Порция'}
            className="inline-input muted"
          />
          <div className="price-row">
            <input
              type="number"
              name="price"
              value={item.price || ''}
              onChange={handleChange}
              placeholder="0"
              inputMode="numeric"
            />
            <span>₽</span>
          </div>
        </div>

        <Switch
          value={!item.onStop}
          name={`stop-${item.id || item.name}`}
          onColor="#4DD863"
          handleToggle={toggleStopList}
        />
        <button type="button" className="icon-button small" onClick={() => setIsExpanded((value) => !value)}>
          <Icon name={isExpanded ? 'expand_less' : 'edit'} />
        </button>
      </div>

      {isExpanded ? (
        <div className="item-edit-panel">
          {item.weight ? (
            <label className="app-field">
              <span>Средний вес</span>
              <input
                type="number"
                name="weight"
                value={item.weight || 0}
                onChange={handleChange}
                inputMode="numeric"
              />
            </label>
          ) : null}
          <label className="app-field">
            <span>Ссылка на изображение</span>
            <input
              type="text"
              name="image"
              value={item.image || ''}
              onChange={handleChange}
              placeholder="https://..."
            />
          </label>
          <label className="app-field">
            <span>Описание</span>
            <textarea
              name="description"
              value={item.description || ''}
              onChange={handleChange}
              placeholder="Описание блюда"
              rows="3"
            />
          </label>
          <button type="button" onClick={confirm} className="danger-button">
            <Icon name="delete_outline" />
            Удалить позицию
          </button>
        </div>
      ) : null}

      <ImageDialog
        dialogVisible={dialogVisible}
        setDialogVisible={setDialogVisible}
        onUpload={handleUpload}
      />
    </article>
  );
}

export default React.memo(ItemEditor);
